/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { pmDocToFragment as F, fragmentToHtml as j, TableMap as A, Selection as O, TextSelection as B, CellSelection as U, addColumnAfter as q, addRowAfter as G, parseContent as J } from "@progress/kendo-editor-common";
import { deleteColumnCmd as K, deleteRowCmd as L } from "../tableEdit.mjs";
import { selectedCells as P, parseStyle as S, nodeSize as _, tableCells as Q, setNodeStyle as h } from "./utils.mjs";
import { parentNode as T } from "../utils.mjs";
const N = {
  rows: 0,
  columns: 0,
  width: null,
  widthUnit: "",
  height: null,
  heightUnit: "",
  position: null,
  textAlign: "",
  cellPadding: null,
  cellSpacing: null,
  backgroundColor: void 0,
  borderWidth: null,
  borderColor: void 0,
  borderStyle: null,
  collapseBorders: !1,
  id: "",
  className: "",
  caption: "",
  captionAlignment: null,
  captionPosition: null,
  headerRows: 0,
  headerColumns: 0,
  associateHeaders: "none"
}, k = {
  left: { "margin-left": "", "margin-right": "auto" },
  center: { "margin-left": "auto", "margin-right": "auto" },
  right: { "margin-left": "auto", "margin-right": "" },
  "": {}
}, z = (n) => {
  const t = [];
  for (let i = 0; i < n.height; i++) {
    const l = i * n.width, e = l + n.width;
    t.push(n.map.slice(l, e));
  }
  return t;
}, V = (n, t) => {
  let i = 0, l = 0;
  const e = z(t);
  e.forEach((o) => {
    let s = !0;
    o.forEach((r) => {
      const c = n.nodeAt(r);
      c && c.type.name !== "table_header" && (s = !1);
    }), s && i++;
  });
  for (let o = 0; o < t.width; o++) {
    let s = !0;
    for (let r = 0; r < t.height; r++) {
      const c = e[r] && e[r][o], u = typeof c == "number" && n.nodeAt(c);
      u && u.type.name !== "table_header" && (s = !1);
    }
    s && l++;
  }
  return { rows: i, columns: l };
}, X = (n) => {
  const t = /* @__PURE__ */ new Set();
  return n.content.forEach((i) => {
    i.content.forEach((l) => {
      t.add(S(l.attrs.style).padding || "");
    });
  }), t.size === 1 ? Array.from(t)[0] : "";
}, Y = (n) => {
  let t = !0, i = !0;
  return n.content.forEach((l) => {
    l.content.forEach((e) => {
      let o = e.type.name === "table_header", s = e.type.name === "table_cell";
      o && !e.attrs.scope && (t = !1), (o && !e.attrs.id || s && !e.attrs.headers) && (i = !1);
    });
  }), t ? "scope" : i ? "id" : "none";
}, ce = (n) => {
  var p, a, b;
  const t = P(n), i = n.selection.$from, l = t.length ? T(i, (f) => f.type.spec.tableRole === "table") : null;
  if (!l)
    return N;
  const e = T(i, (f) => f.type.name === "table_wrapper");
  let o = "", s = {}, r = {};
  e && (r = S(e.node.attrs.style), e.node.content.forEach((f) => {
    if (f.type.name === "table_caption_external") {
      const y = F(f);
      o = j(y), o = o === "<img>" ? "" : o, s = S(f.attrs.style);
    }
  }));
  const c = S(((p = l.node.attrs) == null ? void 0 : p.style) || ""), u = A.get(l.node), d = r["margin-left"] === "auto" && r["margin-right"] === "auto" ? "center" : r["margin-right"] === "auto" ? "left" : r["margin-left"] === "auto" ? "right" : null, g = V(l.node, u), m = X(l.node);
  return {
    ...N,
    columns: u.width,
    rows: u.height,
    ..._(l.node, "width"),
    ...e && /%/.test(r.width || "") ? _(e.node, "width") : {},
    ..._(l.node, "height"),
    textAlign: c["text-align"] || "",
    position: d || null,
    cellPadding: m ? parseFloat(m) : null,
    cellSpacing: c["border-spacing"] ? parseFloat(c["border-spacing"]) : null,
    backgroundColor: c["background-color"],
    borderWidth: c["border-width"] ? parseFloat(c["border-width"]) : null,
    borderColor: c["border-color"],
    borderStyle: c["border-style"] || null,
    collapseBorders: c["border-collapse"] === "collapse",
    caption: o || void 0,
    captionAlignment: s["text-align"] || "",
    captionPosition: s["caption-side"] || null,
    headerRows: g.rows,
    headerColumns: g.columns,
    associateHeaders: g.rows || g.columns ? Y(l.node) : "none",
    id: ((a = l.node.attrs) == null ? void 0 : a.id) || "",
    className: ((b = l.node.attrs) == null ? void 0 : b.class) || ""
  };
}, $ = (n) => {
  const i = n.lastChild.lastChild;
  return { node: i, pos: n.content.size - i.nodeSize };
}, R = (n, t, i, l, e) => {
  const o = $(i), s = t + o.pos;
  if (!n.doc.nodeAt(s))
    return n;
  const c = n.doc.resolve(s), u = new U(c, c), d = n.tr.setSelection(u);
  let g = n.apply(d);
  for (let m = 0; m < l; m++)
    e(g, (p) => {
      g = g.apply(p);
    });
  return g;
}, x = (n, t, i, l) => {
  let e = n;
  for (let o = 0; o < i; o++) {
    const s = e.doc.nodeAt(t);
    if (s) {
      const r = $(s), c = t + r.pos, u = e.doc.resolve(c), d = new U(u, u), g = e.tr.setSelection(d);
      e = e.apply(g), l(e, (m) => {
        e = e.apply(m);
      });
    }
  }
  return e;
}, Z = (n, t, i, l) => {
  let e = n, o = e.doc.nodeAt(t);
  if (!o)
    return e;
  let s = A.get(o);
  return s.width === l && s.height === i || (l > s.width ? e = R(e, t, o, l - s.width, q) : l < s.width && (e = x(e, t, s.width - l, K)), o = e.doc.nodeAt(t), !o) || (s = A.get(o), i > s.height ? e = R(e, t, o, i - s.height, G) : i < s.height && (e = x(e, t, s.height - i, L))), e;
}, W = (n, t, i) => {
  const l = n.doc.nodeAt(i);
  if (!l)
    return n;
  let e = { ...l.attrs };
  const o = t.width !== null && (t.widthUnit !== "%" || !t.caption && !t.position);
  e = h(e, "width", o ? t.width + t.widthUnit : ""), e = h(e, "height", t.height !== null ? t.height + t.heightUnit : ""), e = h(e, "text-align", t.textAlign || ""), e = h(e, "background-color", t.backgroundColor || ""), e = h(e, "border-width", t.borderWidth ? t.borderWidth + "px" : ""), e = h(e, "border-style", t.borderStyle || ""), e = h(e, "border-color", t.borderColor || ""), e = h(e, "border-spacing", t.cellSpacing !== null ? t.cellSpacing + "px" : ""), t.cellSpacing !== null ? e = h(e, "border-collapse", "unset") : e = h(e, "border-collapse", t.collapseBorders ? "collapse" : "");
  const s = k[t.position || ""] || {};
  Object.keys(s).forEach((c) => {
    e = h(e, c, s[c]);
  }), e.id = t.id || null, e.class = t.className || null;
  const r = n.tr.setNodeMarkup(i, null, e);
  return n = n.apply(r), n;
}, H = (n, t, i, l, e) => {
  if (t.type.name !== l.name || Object.keys(e).length > 0) {
    const o = n.tr.setNodeMarkup(i, l, { ...t.attrs, ...e });
    return n.apply(o);
  }
  return n;
}, I = (n, t) => {
  /^cell-[0-9]+-[0-9]+$/.test(n.attrs.id || "") && (t.id = null);
}, ee = (n, t, i) => {
  const l = n.doc.nodeAt(i), e = l && A.get(l);
  if (!l || !e)
    return n;
  const o = z(e);
  let s = n;
  const { table_header: r, table_cell: c } = n.schema.nodes, u = String((/* @__PURE__ */ new Date()).getTime()), d = [], g = (p, a) => {
    const b = `cell-${p}${a}-${u}`;
    return d[p] || d.push([]), d[p][a] || d[p].push([]), d[p][a] = b, b;
  }, m = (p, a, b, f) => {
    const y = [];
    if (f)
      for (let w = 0; w < p; w++)
        d[w] && d[w][a] && y.push(d[w][a]);
    if (b)
      for (let w = 0; w < a; w++)
        d[p] && d[p][w] && y.push(d[p][w]);
    return y.join(" ");
  };
  return o.forEach((p, a) => {
    p.forEach((b, f) => {
      const y = l.nodeAt(b);
      if (y) {
        const w = f < t.headerColumns, E = a < t.headerRows, C = { ...y.attrs };
        I(y, C), C.headers = null, C.scope = null, E || w ? (t.associateHeaders === "scope" && (C.scope = E ? "col" : "row"), t.associateHeaders === "id" && (C.id = g(a, f), (f > 0 || a > 0) && (C.headers = m(a, f, w, E) || null)), s = H(s, y, i + b + 1, r, C)) : (t.associateHeaders === "id" && (C.headers = m(a, f, t.headerColumns > 0, t.headerRows > 0) || null), s = H(s, y, i + b + 1, c, C));
      }
    });
  }), s;
}, te = (n, t, i, l) => {
  let e = { ...t.attrs };
  return e = h(e, "margin-left", ""), e = h(e, "margin-right", ""), Object.keys(l || {}).forEach((o) => {
    e = h(e, o, (l || {})[o] || "");
  }), n.apply(n.tr.setNodeMarkup(i, null, e));
}, v = (n, t) => J("<p>" + n + "</p>", t).content.firstChild.content, M = (n, t) => {
  if (!n.caption)
    return;
  let i = { caption: "", style: "display: table-caption" };
  n.captionAlignment && (i = h(i, "text-align", n.captionAlignment)), n.captionPosition && (i = h(i, "caption-side", n.captionPosition));
  const l = v(n.caption, t);
  return l && t.nodes.table_caption_external.createAndFill(i, l) || void 0;
}, D = (n) => n.firstChild && n.firstChild.type.name === "table_caption_external", ne = (n, t, i, l) => {
  let e = n, o;
  const s = i + 2, r = i + 1, c = e.schema;
  if (D(t))
    if (o = t.firstChild, l.caption) {
      const u = v(l.caption, c);
      if (e = e.apply(
        e.tr.replaceWith(s, s + o.content.size, u)
      ), o = e.doc.nodeAt(r), o) {
        let d = { ...o.attrs };
        d = h(d, "text-align", l.captionAlignment || ""), d = h(d, "caption-side", l.captionPosition || ""), e = e.apply(e.tr.setNodeAttribute(r, "style", d.style));
      }
    } else
      e = e.apply(e.tr.deleteRange(s, s + o.content.size));
  else
    o = M(l, c), o && (e = e.apply(e.tr.replaceWith(r, r, o)));
  return e;
}, oe = (n, t, i, l, e) => {
  let o = {
    state: n,
    pos: i
  };
  if (!l && (t.position || t.caption)) {
    let r = { table: "", style: "display: table" };
    const c = [], u = t.position, d = u && k[u];
    d && Object.keys(d).forEach((a) => {
      r = h(r, a, d[a] || "");
    }), typeof t.width == "number" && t.widthUnit === "%" && (r = h(r, "width", t.width + t.widthUnit));
    const g = M(t, n.schema);
    g && c.push(g);
    const m = n.doc.nodeAt(i);
    c.push(m);
    const p = n.schema.nodes.table_wrapper.createAndFill(r, c);
    if (p) {
      const a = n.tr.replaceWith(i, i + m.content.size, p);
      n = n.apply(a), o = { state: n, pos: i };
    }
  } else
    l && (t.position || t.caption || !t.caption && D(l.node)) ? (n = te(n, l.node, e, t.position && k[t.position]), n = ne(n, l.node, e, t), o = { state: n, pos: e }) : l && !(t.position || t.caption) ? o = { state: n, node: l.node, pos: n.selection.$from.start(l.depth) - 1 } : o = { state: n, pos: i };
  const s = l && o.state.doc.nodeAt(e);
  if (s) {
    let r;
    typeof t.width == "number" && t.widthUnit === "%" ? r = h(s.attrs, "width", t.width + t.widthUnit) : t.widthUnit !== "%" && /%/.test(S(s.attrs.style || "").width || "") && (r = h(s.attrs, "width", "")), r && (o.state = o.state.apply(o.state.tr.setNodeMarkup(e, null, r)));
  }
  return o;
}, de = (n, t) => {
  const i = n.selection.$from;
  let l = T(i, (f) => f.type.spec.tableRole === "table");
  if (!l)
    return;
  const e = i.start(l.depth) - 1;
  let o = Z(n, e, t.rows, t.columns);
  if (!o)
    return;
  const s = o.tr;
  Q(o).forEach((f) => {
    let y = { ...f.node.attrs };
    y = h(y, "padding", typeof t.cellPadding == "number" ? t.cellPadding + "px" : ""), s.setNodeMarkup(f.pos, null, y);
  }), o = o.apply(s), o = W(o, t, e), o = ee(o, t, e);
  const r = T(i, (f) => f.type.name === "table_wrapper"), c = i.start((r == null ? void 0 : r.depth) || 0) - 1;
  let u = oe(o, t, e, r, c);
  o = u.state;
  const d = u.pos, g = o.doc.nodeAt(u.pos);
  if (!g)
    return;
  const m = d + (r || l).node.content.size, p = n.tr.replaceWith(d, m, g), a = O.atEnd(g), b = B.create(p.doc, d + a.to + 1);
  return p.setSelection(b), p;
};
export {
  de as applyTableData,
  N as initialTableData,
  ce as tableDefaultData,
  k as tablePositionStyles
};
